import { TableHeaderCell } from '@components/Table/TableHeaderCell';
import { IData } from '@hooks/useData';
import { Table, TableHead, TableRow, TableBody, TableCell, makeStyles } from '@material-ui/core';
import React from 'react';
import { IAtividadeDiferenca } from './AtividadeDiferencaModal';
import clsx from 'clsx';

export type AtividadeDiferencaTableProps = {
    data: IData<IAtividadeDiferenca>
}

export function AtividadeDiferencaTable ({data }: AtividadeDiferencaTableProps) {
    const cls = useStyles();

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableHeaderCell>Dado</TableHeaderCell>
                    <TableHeaderCell>Valores Antigos</TableHeaderCell>
                    <TableHeaderCell>Novos Valores</TableHeaderCell>
                </TableRow>
            </TableHead>

            <TableBody>
            {
                data.items.map((atividadeDiferenca, index) => {
                    return (
                        <TableRow key={index}>
                            <TableCell>{atividadeDiferenca.key}</TableCell>
                            <TableCell>{atividadeDiferenca.old}</TableCell>
                            <TableCell className={clsx({
                                [cls.different]: atividadeDiferenca.old !== atividadeDiferenca.new
                            })}>{atividadeDiferenca.new}</TableCell>
                        </TableRow>
                    )
                })
            }
            </TableBody>
        </Table>
    )
}

const useStyles = makeStyles(theme => ({
    different: {
        fontWeight: 'bold',
        color: 'red'
    }
}));